import { SvgIcon } from '@material-ui/core';
import React from 'react';

import { ReactComponent as PharmacySvg } from 'src/pharmacyRecommendations/icons/pharmacy.svg';

export const PharmacySvgIcon = () => (
  <SvgIcon viewBox="0 0 44 44">{React.createElement(PharmacySvg)}</SvgIcon>
);
